// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.int-video-details__data-cont[data-v-7fa3a296] {\n  margin: 0 -30px;\n  padding: 0 30px;\n  border-top: 20px solid white;\n  background: #e9ebef;\n}\n@media (max-width: 767px) {\n.int-video-details__data-cont[data-v-7fa3a296] {\n    margin: 0 -15px;\n    padding: 0 15px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
